module.exports = __webpack_public_path__ + "static/media/gaizao-qinhuairenminzhengfu.57c9aa5d.jpg";